import { computed, nextTick, ref, Ref, watch, WatchStopHandle } from 'vue';
import { IMultiSelect } from '@studyportals/multiselect/dist/src/interfaces/multiselect.interface';
import { IOption } from '@studyportals/multiselect/dist/src/interfaces/options.interface';
import { ValidationProperties } from '@/models/validation.interface';
import { LoadingStatuses, LoadingTypes } from '@/models/loading.interface';
import validationPresenter from '@/presenters/validation-presenter';
import store from '@/store';

export default class ClientServicesPersonCode {
	public clientServicesPersonDropdown: Ref<IMultiSelect | null> = ref(null);
	private unwatchPrimary: WatchStopHandle | null = null;
	private unwatchClientServicesPerson: WatchStopHandle | null = null;

	public get loadingType(): LoadingTypes {
		return LoadingTypes.CLIENT_SERVICES_PEOPLE;
	}

	public clientServicesPerson = computed((): number | null => {
		return store.getters.clientServicesPerson();
	});

	public options = computed((): IOption[] => {
		return store.getters.allClientServicesPeople();
	});

	public isLoading = computed((): boolean => {
		return this.isClientServicesPersonDataLoading.value || this.isPrimaryDataLoading.value;
	});

	private isClientServicesPersonDataLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusClientServicesPeople();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	private isPrimaryDataLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.CLIENT_SERVICES_PERSON);
	});

	private isClientServicesPersonSet = computed((): boolean => {
		return this.clientServicesPerson.value !== null;
	});

	public mounted(): void {
		this.unwatchClientServicesPerson = watch(this.isClientServicesPersonDataLoading, this.prefillClientServicesPerson.bind(this));
		this.unwatchPrimary = watch(this.isPrimaryDataLoading, this.prefillClientServicesPerson.bind(this));
		void this.prefillClientServicesPerson();
	}

	public unmounted(): void {
		if (this.unwatchPrimary) {
			this.unwatchPrimary();
		}
		if (this.unwatchClientServicesPerson) {
			this.unwatchClientServicesPerson();
		}
	}

	public setClientServicesPerson(option: IOption): void {
		store.mutations.setClientServicesPerson(option.value as number);

		if (!this.isFieldValidatedAndMissing.value) {
			return;
		}

		validationPresenter.validateMandatoryFields();
	}

	private async prefillClientServicesPerson(): Promise<void> {
		if (this.isLoading.value) {
			return;
		}

		await nextTick();

		if (!this.clientServicesPersonDropdown.value || !this.isClientServicesPersonSet.value) {
			return;
		}

		const selectedOption = this.options.value.find((option) => option.value === this.clientServicesPerson.value);
		if (!selectedOption) {
			return;
		}

		this.clientServicesPersonDropdown.value.selectOption(selectedOption);
	}
}
